import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class CrmCaseMove extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: false,
            newTeamId: this.getDefaultGuid(),
            newStatusId: this.getDefaultGuid(),
            description: ''
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.state.nextStep === 0) {
            this.showErorrMessage("لطفا نتیجه بررسی را مشخص نمایید");
            return;
        }

        this.httpPost("api/v1/crm/case/move", {
            id: this.state.id,
            newTeamId: this.state.newTeamId,
            newStatusId: this.state.newStatusId,
            description: this.state.description
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("ادامه این پیگیری به تیم انتخاب شده واگذار گردید");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setTeam(e) {
        this.setState({ newTeamId: e.value });
    }
    setCrmCaseStatus(e) {
        this.setState({ newStatusId: e.value });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "90%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">تغییر تیم پیگیری کننده</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">تیم:</label>
                                            <SelectAsync
                                                isMulti={false}
                                                placeholder="انتخاب تیم"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadCrmTeamsOptions(inputValue, callback)}
                                                onChange={e => this.setTeam(e)}
                                            />
                                        </div>
                                    </div>
                                    {this.state.newTeamId != this.getDefaultGuid() && <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">وضعیت:</label>
                                            <SelectAsync
                                                isMulti={false}
                                                placeholder="انتخاب وضعیت"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadCrmCaseStatusOptions(inputValue, callback, this.state.newTeamId)}
                                                onChange={e => this.setCrmCaseStatus(e)}
                                            />
                                        </div>
                                    </div>}
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">توضیحات:</label>
                                            <input defaultValue={this.state.description} onChange={e => this.state.description = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}